import { useQuery } from "@tanstack/react-query";
import { isRecette } from "@src/helper/environnement.helper";
import {
  AnalyseEstimationScopeParams,
  ControleQuinquennalApi,
} from "../controle-quinquennal.api";
import { controleQuinquennalKeys } from "./controle-quinquennal.keys";

/**
 * Estimation coût/durée d'un lancement CQ
 * (conception EN-1476 §5), préchargée au montage de la
 * page — jamais au clic du bouton de lancement. `useDialog` fige ses props à
 * l'ouverture (`useDialog.ts:47`) : rien ne peut être réinjecté dans la
 * modale après coup, donc pas de spinner ni de refetch déclenché depuis la
 * modale elle-même. Donnée absente (chargement, erreur, en production, ou
 * estimation sous le seuil côté gateway) → le bloc estimation est simplement
 * omis, jamais de valeur de repli. En production la requête n'est pas émise
 * du tout (la gateway y répond 403).
 */
export const useAnalyseEstimationQuery = (
  idControleQuinquennal: string | undefined,
  params: AnalyseEstimationScopeParams
) => {
  return useQuery({
    queryKey: controleQuinquennalKeys.analyseEstimation(
      idControleQuinquennal ?? "",
      params
    ),
    queryFn: () =>
      ControleQuinquennalApi.getAnalyseEstimation(
        idControleQuinquennal as string,
        params
      ),
    enabled: Boolean(idControleQuinquennal) && isRecette,
    staleTime: 30_000,
  });
};
